import { metaData, registerImageLoader } from '@cornerstonejs/core';
import loadImage from './loadImage';
import { metaDataProvider } from './metaData';
import { registerDefaultProviders } from '@cornerstonejs/metadata';
export default function (options) {
    registerImageLoader('wadors', loadImage);
    if (options?.useLegacyMetadataProvider) {
        console.warn('wadors metaDataProvider is deprecated. Use addDicomWebInstance from @cornerstonejs/metadata instead.');
        metaData.addProvider(metaDataProvider);
        return;
    }
    registerDefaultProviders();
    metaData.addProvider(metaDataProvider);
}
